import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { format } from '@/@core/utils/string';
let CacheManagementApi = class CacheManagementApi {
    constructor(http, url) {
        this.http = http;
        this.url = url;
    }
    getRedisNamespaces() {
        return this.http.get({
            url: this.url.redis_namespaces,
        });
    }
    getRedisValue(params) {
        return this.http.get({
            url: this.url.redis_keys_value,
            params,
        });
    }
    synchronizationRedis() {
        return this.http.post({
            url: this.url.synchronization_resource_info_redis,
        });
    }
    synchronizationRedisByType(params) {
        const url = format(this.url.synchronization_resource_redis_type, params);
        return this.http.post({
            url,
        });
    }
    updateTopic() {
        return this.http.post({
            url: this.url.update_topic,
        });
    }
};
CacheManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CacheManagementUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CacheManagementApi);
export { CacheManagementApi };
